module.exports = __webpack_public_path__ + "static/c3-f6ea1c10f116339d5fadbff80c9a19a5.jpg";